import _defineProperty from '@babel/runtime/helpers/defineProperty';
import formatPrice from '@bwoty-web/price-formatter';
import cardTexts from '../Card.texts.js';
import { PriceSummary as PriceSummary$2, DiscountPercentage, Price, GrayPriceText, OriginalPrice } from './PriceSummary.style.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import useGlobals from '../../../hooks/useGlobals.js';
import useIsGlobetrotter from '../../../hooks/useIsGlobetrotter.js';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var PriceSummary = function PriceSummary(_ref) {
  var _ref$discountDisplayT = _ref.discountDisplayType,
    discountDisplayType = _ref$discountDisplayT === void 0 ? 'original' : _ref$discountDisplayT,
    _ref$originalPrice = _ref.originalPrice,
    originalPrice = _ref$originalPrice === void 0 ? null : _ref$originalPrice,
    _ref$originalPricePer = _ref.originalPricePerPerson,
    originalPricePerPerson = _ref$originalPricePer === void 0 ? null : _ref$originalPricePer,
    price = _ref.price,
    _ref$pricePerPerson = _ref.pricePerPerson,
    pricePerPerson = _ref$pricePerPerson === void 0 ? null : _ref$pricePerPerson,
    _ref$pricePerPersonFo = _ref.pricePerPersonFocus,
    pricePerPersonFocus = _ref$pricePerPersonFo === void 0 ? false : _ref$pricePerPersonFo,
    _ref$showPriceFromPre = _ref.showPriceFromPrefix,
    showPriceFromPrefix = _ref$showPriceFromPre === void 0 ? false : _ref$showPriceFromPre,
    cardSettings = _ref.cardSettings;
  var _useGlobals = useGlobals(),
    culture = _useGlobals.culture,
    siteId = _useGlobals.siteId;
  var isGlobetrotter = useIsGlobetrotter();
  var texts = cardTexts[culture];
  var hasDiscount = !pricePerPersonFocus && originalPrice > price;
  var hasPricePerPersonDiscount = pricePerPersonFocus && originalPricePerPerson > pricePerPerson;
  var priceDifference = originalPrice - price;
  var pricePerPersonDifference = originalPricePerPerson - pricePerPerson;
  var priceDiffPercentage = Math.floor(priceDifference / originalPrice * 100);
  var displayPriceDiffPercentage = priceDiffPercentage >= 10 && !isGlobetrotter && discountDisplayType === 'discountDisplayType'; // ??? 

  var checkedPrice = pricePerPersonFocus ? pricePerPerson : price;
  var checkedOriginalPrice = pricePerPersonFocus ? originalPricePerPerson : originalPrice;
  var checkedDiscount = pricePerPersonFocus ? pricePerPersonDifference : priceDifference;
  var potentialDiscount = function potentialDiscount() {
    var hasNoDiscount = !hasDiscount && !hasPricePerPersonDiscount;
    if (discountDisplayType === 'hide' || hasNoDiscount) {
      return null;
    }
    if (discountDisplayType === 'discount') {
      return /*#__PURE__*/jsx(GrayPriceText, {
        children: "".concat(formatPrice(checkedDiscount, siteId), " ").concat(texts.discount)
      });
    }
    return /*#__PURE__*/jsx(OriginalPrice, {
      children: formatPrice(checkedOriginalPrice, siteId)
    });
  };
  var getMainPriceText = function getMainPriceText() {
    var fromText = showPriceFromPrefix ? texts.priceFrom : '';
    return "".concat(fromText).concat(formatPrice(checkedPrice, siteId));
  };
  return /*#__PURE__*/jsxs(PriceSummary$2, _objectSpread(_objectSpread({
    $noPriceInfo: !checkedPrice
  }, cardSettings), {}, {
    children: [displayPriceDiffPercentage && /*#__PURE__*/jsx(DiscountPercentage, {
      children: "-".concat(priceDiffPercentage, "%")
    }), potentialDiscount(), /*#__PURE__*/jsx(Price, {
      $hasDiscount: hasDiscount || hasPricePerPersonDiscount,
      children: getMainPriceText()
    }), pricePerPerson && !pricePerPersonFocus && /*#__PURE__*/jsx(GrayPriceText, {
      children: "".concat(formatPrice(pricePerPerson, siteId)).concat(texts.perPerson)
    }), pricePerPersonFocus && /*#__PURE__*/jsx(GrayPriceText, {
      children: texts.pricePerPerson
    })]
  }));
};
var PriceSummary$1 = PriceSummary;

export { PriceSummary$1 as default };
//# sourceMappingURL=PriceSummary.js.map
